import { useQuery } from "@tanstack/react-query";
import $api from "@/zapi-admin/shared/api/axios";
import { AiLogSchema } from "../model/types";

export function useAiLogDetails(logId: number | null) {
  const { data, isPending, isLoading, refetch } = useQuery({
    queryKey: ["get-ai-log-detail", logId],
    queryFn: async () => {
      const response = await $api.get(`/admin/ai-logs/${logId}`);
      return AiLogSchema.parse(response.data);
    },
    enabled: !!logId
  });

  return { data, isPending, refetch, isLoading };
}
